import type { FunnelSnapshotResponse } from '@rheora/enrollment-contract';

/**
 * E-CRM04 — the `/resume/continue` page's decisions. PURE.
 *
 * The page exists so that the resume link's GET does not redeem: the BFF only
 * HOLDS the token and sends the visitor here; pressing Continue redeems. A mail
 * scanner that prefetches the link never presses anything.
 */

export type ResumeContinueEntry =
  /** Still asking the BFF what this session holds. */
  | { readonly kind: 'loading' }
  /** A token is held: show the Continue button. */
  | { readonly kind: 'ready' }
  /** Nothing held (used already, refreshed after use, opened directly, or no session). */
  | { readonly kind: 'expired' };

export interface ResumeContinueEntryInput {
  readonly isPending: boolean;
  readonly isError: boolean;
  readonly snapshot: FunnelSnapshotResponse | undefined;
}

/** Whether the page can offer Continue, from the funnel snapshot read. */
export function decideContinueEntry(input: ResumeContinueEntryInput): ResumeContinueEntry {
  if (input.isPending) return { kind: 'loading' };
  if (input.isError || input.snapshot === undefined) return { kind: 'expired' };
  return input.snapshot.resumeTokenHeld ? { kind: 'ready' } : { kind: 'expired' };
}
